<template>
  <v-row>
    <v-col 
      sm="1" 
      lg="2" 
      class="hidden-xs-only"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="regresar"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>

    <v-col 
      cols="12" 
      sm="10" 
      lg="8"
    >
      <DetailCard 
        title="Detalles Habilidad" 
        :loading="cardLoading"
      >
        <v-row justify="center">
          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Código de Habilidad
            </p>
            <p class="text-subtitle-1">
              {{ habilidad.codigo_habilidad }}
            </p>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Habilidad
            </p>
            <p class="text-subtitle-1">
              {{ habilidad.categoria }}
            </p>
          </v-col>

          <v-col 
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Descripción
            </p>
            <template v-if="habilidad.descripcion != ''">
              <p class="text-subtitle-1">
                {{ habilidad.descripcion }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

          <v-col
            cols="12"
            sm="10"
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              Programas de Formación
            </p>
            <template v-if="habilidad.programa_formacion_categoria != null">
              <p v-for="programa_formacion_categoria in habilidad.programa_formacion_categoria"
                :key="programa_formacion_categoria.programa_formacion.id_programa_formacion"
                  class="text-subtitle-1"
              >
                {{ programa_formacion_categoria.programa_formacion.programa_formacion }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrados
              </p>
            </template>
          </v-col>

          <v-col
            cols="12"
            sm="10"
            lg="8"
          >
            <div v-for="(doc, i) in documentos" :key="i" class="mb-4">
              <p class="text-subtitle-1 mb-2">
                {{ doc.nombre_documento }}
              </p>

              <v-btn
                color="primary"
                @click="downloadeDocumentos(doc.nombre_documento)"
              >
                Descargar
                <v-icon right>mdi-cloud-download</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>

<script>
import DetailCard from "../../../components/admin/DetailCard.vue";

export default {
  data: () => ({
    cardLoading: true,
  }),

  components: {
    DetailCard,
  },

  mounted() {
    this.$store.dispatch("detallesHabilidad", this.$route.params.id_habilidad);
    this.$store.dispatch("gestionarDocumentos", this.$route.params.id_habilidad);

    setTimeout(() => {
      this.cardLoading = false;
    }, 1000);
  },

  computed: {
    habilidad() {
      return this.$store.getters.obtenerHabilidad;
    },

    documentos() {
      return this.$store.getters.obtenerDocumentos;
    }
  },

  methods: {
    downloadeDocumentos(nombredocumento) {
      this.$store.dispatch("downloadeHabilidad", {
        categoria_id: this.$route.params.id_habilidad,
        nombre_documento: nombredocumento,
      })
      .then((response) => {
        const urlReporte = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = urlReporte;
        link.setAttribute("download", nombredocumento + ".pdf");
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        this.alert = true;
        this.titleAlert = "Error";
        this.messageAlert = "El documento " + nombredocumento + " no tiene documento registrado";
        this.titleCard = "error--text";
      });
      
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    regresar() {
      this.$router.back();
    },
  },
};
</script>
